'use client';
import type { StateAbbreviation } from '@repo/supergraph/marketplace/types';
import type {
  CategorySection as CategorySectionType,
  ProductCard as ProductCardType,
} from '@repo/supergraph/roundup/base/types';
import ProductCardCategorySections from '@repo/ui/roundups/components/ProductCardCategorySections';
import {
  useGetOffersFilterOffers,
  useOffersFilterStore,
} from '../roundups/components/OffersFilter/store';

type ProductCardCategorySectionsProps = {
  categorySections: CategorySectionType[];
  isSeoBankingFFActive: boolean;
  regionCode?: StateAbbreviation;
  showSkeleton?: boolean;
  offers?: ProductCardType[];
  isLoading?: boolean;
  slug?: string;
  shouldApplyStylingUpdates?: boolean;
};

export const ProductCardCategorySectionsWrapper = (props: ProductCardCategorySectionsProps) => {
  const offers = useGetOffersFilterOffers();
  const isLoading = useOffersFilterStore(state => state.isLoading);
  const sortBy = useOffersFilterStore(state => state.sortBy);
  return (
    <ProductCardCategorySections
      {...props}
      offersListToFilterWith={offers}
      isLoading={isLoading}
      isSorted={sortBy !== ''}
      isFilterEnabled
    />
  );
};
